
export default {
  name: 'rzIconVk',
  props: {
    width: {
      type: Number,
      default: 38,
    },
    height: {
      type: Number,
      default: 35,
    },
  },
};
